import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Home = () => import('../views/Home.vue')
const Login = () => import('../views/Login.vue')
const Register = () => import('../views/Register.vue')
const ProductDetail = () => import('../views/ProductDetail.vue')
const Orders = () => import('../views/Orders.vue')
const Profile = () => import('../views/Profile.vue')

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'Home', component: Home },
    { path: '/login', name: 'Login', component: Login },
    { path: '/register', name: 'Register', component: Register },
    { path: '/product/:id', name: 'ProductDetail', component: ProductDetail },
    { path: '/orders', name: 'Orders', component: Orders, meta: { auth: true } },
    { path: '/profile', name: 'Profile', component: Profile, meta: { auth: true } }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.auth && !localStorage.getItem('token')) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  next()
})

export default router
